import React from 'react';
import TableRowCell from './TableCell';
const TableRow = ({ data, columns, bulkActionEnabled, onSelectClicked, checkedItems }) => {
    return (
        <>
            {data && data.length > 0 ? data.map((item, itemIndex) => (
                <tr key={`table-body-${itemIndex}`}>
                    {
                        bulkActionEnabled ? <th><input
                            type="checkbox"
                            className='table-check'
                            checked={checkedItems[itemIndex]}
                            onChange={() => { onSelectClicked(!checkedItems[itemIndex], item, itemIndex); }}
                        /></th> : null
                    }
                    {columns.map((column, columnIndex) => (
                        <TableRowCell
                            key={`table-row-cell-${columnIndex}`}
                            item={item}
                            index={itemIndex}
                            column={column}
                        />
                    ))}
                </tr>
            )) : <tr><td>{"No data found..."}</td></tr>}
        </>
    );
}
export default TableRow;